module.exports = __webpack_public_path__ + "img/sk.1da1c0a.svg";